// Start the wrapper as early as possible, but only once.
// The auction no longer waits for full window.load; this keeps first ad request timing closer to DOM readiness.
function startWrapperOnce() {
    if (!window.prebidAuctionRun) {
        window.prebidAuctionRun = true;
        clearTimeout(window.adsLoadTimer);
        runWrapper();
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startWrapperOnce);
} else {
    setTimeout(startWrapperOnce, 0);
}

// Safety fallback in case DOMContentLoaded is delayed or missed by the integration.
window.adsLoadTimer = setTimeout(startWrapperOnce, 2000);
window.addEventListener('load', startWrapperOnce);

// Reference to the global command queue for asynchronous execution of GPT-related calls.
var googletag = googletag || {};
googletag.cmd = googletag.cmd || [];

// Reference to the global command queue for asynchronous execution of Prebid-related calls.
var pbjs = pbjs || {};
pbjs.que = pbjs.que || [];

// Amount of time (ms) that Prebid allows the bidders to respond to ad requests.
var PREBID_TIMEOUT = 1500;
// Longest time (ms) the first Prebid auction waits for the CMP's final consent answer.
var CONSENT_TIMEOUT_MS = 8000;
// Initial GPT request failsafe (ms): starts counting once consent is final (see startInitialAdserverFailsafe).
var INITIAL_ADSERVER_FAILSAFE_MS = PREBID_TIMEOUT + 500;
// Absolute ceiling (ms, from script start) for the initial GPT request, whatever the CMP does.
var INITIAL_ADSERVER_CEILING_MS = CONSENT_TIMEOUT_MS + PREBID_TIMEOUT + 500;
// Set once the consent-aware failsafe timer has been armed.
var initialAdserverFailsafeArmed = false;

// Number of seconds to wait after the slot becomes viewable.
var SECONDS_TO_WAIT_AFTER_VIEWABILITY = 30;
var SECONDS_TO_WAIT_AFTER_VIEWABILITY_FAST = 20;
var GAM_FAST_REFRESH_ADUNITS = ['Adhesion', 'Billboard'];

// Advertisers for which refresh shouldn't apply. Just add the company IDs e.g [3219368852, 3130234283].
var GAM_NOREFRESH_ADVERTISER_IDS = [];

// Campaigns for which refresh shouldn't apply. Just add the order IDs e.g [3219368852, 3130234283].
var GAM_NOREFRESH_ORDER_IDS = [];

// Ad units (div ids) for which refresh shouldn't apply. Just add the div IDs e.g ['Branding_Left', 'Branding_Right'].
var GAM_NOREFRESH_ADUNITS = ['Branding_Left', 'Branding_Right', 'Citulje_P1'];

// How far should the ad be for the lazy loading to activate.
var DISTANCE_IN_PIXELS_FOR_LAZY_LOADING = "500px";

// How much (in percent) should the ad slot be viewable. 
var VISIBILITY_PERCENT_FOR_REFRESH = 0.6;

// Variables for all defined slots. 
var Adhesion;
var Branding_Left;
var Branding_Right;
var Billboard;
var Billboard_3;
var Billboard_4;
var Billboard_5;
var Billboard_6;
var Billboard_7;
var P1;
var P2;
var P3;
var P4;
var P5;
var P6;
var P7;
var P8;
var P9;
var P10;
var P11;
var P12;
var InText_1;
var InText_2;
var InText_3;
var InText_4;
var InText_5;
var Citulje_P1; 
var Billboard2_Homepage;

// Top level ad unit path. 
var adUnitPath = "/34670701/novosti.rs/";

var adWindowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth; //check user's screen width
var PREBID_LABELS = adWindowWidth >= 1024 ? ['desktop'] : ['mobile']; // active Prebid labels for bidder-level labelAny filtering

// ATF and BTF array variables. 
var adUnitsATF = [];
var adUnitsBTF = [];

// Permanent slot-destruction state for the Performax pxAdClosed event.
// Once destroyed, Adhesion must not be requested, refreshed, or recreated during this pageview.
var destroyedAdSlots = {};
var refreshIntervalsBySlotId = {};
var refreshObserversBySlotId = {};

function isAdSlotDestroyed(slotId) {
    return destroyedAdSlots[slotId] === true;
}

function removePrebidAdUnitSafe(slotId) {
    try {
        if (window.pbjs && typeof pbjs.removeAdUnit === 'function') {
            pbjs.removeAdUnit(slotId);
        }
    } catch (err) {
        // GPT/DOM destruction must continue even if Prebid cleanup is unavailable.
    }
}

function destroyAdSlotPermanently(slotId) {
    if (!slotId || isAdSlotDestroyed(slotId)) {
        return;
    }

    destroyedAdSlots[slotId] = true;

    if (refreshIntervalsBySlotId[slotId]) {
        clearInterval(refreshIntervalsBySlotId[slotId]);
        delete refreshIntervalsBySlotId[slotId];
    }

    if (refreshObserversBySlotId[slotId]) {
        try {
            refreshObserversBySlotId[slotId].disconnect();
        } catch (err) {}
        delete refreshObserversBySlotId[slotId];
    }

    // Remove the unit from pending Prebid arrays as well as the live Prebid registry.
    adUnitsATF = adUnitsATF.filter(function(unit) { return unit && unit.code !== slotId; });
    adUnitsBTF = adUnitsBTF.filter(function(unit) { return unit && unit.code !== slotId; });

    if (window.pbjs && pbjs.que) {
        pbjs.que.push(function() {
            removePrebidAdUnitSafe(slotId);
        });
    } else {
        removePrebidAdUnitSafe(slotId);
    }

    googletag.cmd.push(function() {
        var slotsToDestroy = [];

        try {
            slotsToDestroy = googletag.pubads().getSlots().filter(function(slot) {
                return slot && slot.getSlotElementId && slot.getSlotElementId() === slotId;
            });
        } catch (err) {}

        if (slotsToDestroy.length) {
            try {
                googletag.destroySlots(slotsToDestroy);
            } catch (err) {}
        }

        if (slotId === 'Adhesion') {
            Adhesion = null;
        }
    });

    // Remove every matching responsive duplicate and the wrapper-created background.
    document.querySelectorAll('#' + slotId).forEach(function(element) {
        if (element && element.parentNode) {
            element.parentNode.removeChild(element);
        }
    });

    if (slotId === 'Adhesion') {
        var background = document.getElementById('adhesion_background');
        if (background && background.parentNode) {
            background.parentNode.removeChild(background);
        }
    }
}

window.addEventListener('pxAdClosed', function() {
    destroyAdSlotPermanently('Adhesion');
});

// Returns true when the element is actually visible/rendered.
// This is used because some responsive templates may output duplicate ad div IDs,
// with only one version visible through CSS.
function isWrapperAdElementVisible(el) {
    if (!el || !window.getComputedStyle) {
        return false;
    }

    var style = window.getComputedStyle(el);
    return style.display !== 'none' &&
           style.visibility !== 'hidden' &&
           style.opacity !== '0' &&
           el.getClientRects &&
           el.getClientRects().length > 0;
}

// Returns one ad container per div id.
// If duplicate ids exist, prefer the visible element so GPT binds to the real responsive slot.
// This prevents GPT errors like: "Div element is already associated with another slot".
function getUniqueWrapperAdContainers() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll('.wrapperAd'));
    var byId = {};

    nodes.forEach(function(el) {
        if (!el || !el.id) {
            return;
        }

        if (!byId[el.id]) {
            byId[el.id] = el;
            return;
        }

        var currentVisible = isWrapperAdElementVisible(byId[el.id]);
        var newVisible = isWrapperAdElementVisible(el);

        if (!currentVisible && newVisible) {
            byId[el.id] = el;
        }
    });

    return Object.keys(byId).map(function(id) {
        return byId[id];
    });
}

// Checks if GPT already has a slot for this div id.
// Used as a second safety net if the wrapper is loaded twice or the page already defined a slot.
function isGptSlotAlreadyDefined(divId) {
    try {
        if (!googletag || !googletag.pubads || !googletag.pubads().getSlots) {
            return false;
        }

        return googletag.pubads().getSlots().some(function(slot) {
            return slot && slot.getSlotElementId && slot.getSlotElementId() === divId;
        });
    } catch (e) {
        return false;
    }
}

function runWrapper() {

    //console.log('Ad Wrapper: Script execution.');

    var adContainers = getUniqueWrapperAdContainers(); // one visible container per id, duplicate-safe

    googletag.cmd.push(function() { // Push the defined ad units to the GPT array.

        // Sticky GPT size mapping. 
        var sticky_mapping = googletag.sizeMapping()
        .addSize([1600, 0], [[728, 90], [970, 90], [980, 90], [1000, 100], [750, 100], [750, 200]]) //desktop for bigger screens
        .addSize([1024, 0], [[728, 90], [750, 100]]) //desktop for smaller screens
        .addSize([469, 0], [[468, 60], [300, 50], [320, 50]]) //tablet
        .addSize([0, 0], [[300, 50], [320, 50], [300, 100], [320, 100]]) //mobile
        .build();

        // Billboard GPT size mapping.
        var billboard_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[728, 90], [970, 66], [950, 90], [970, 90], [980, 90], [1000, 100], [750, 100], [750, 200], [980, 120], [930, 180], [970, 250], [980, 240], [980, 250], [990, 250], [1060, 250]]) //desktop
        .addSize([469, 0], [[468, 60], [300, 50], [320, 50]]) //tablet
        .addSize([0, 0], [[300, 50], [300, 75], [320, 80], [320, 50], [300, 100], [320, 100]]) //mobile
        .build();   

        // Branding GPT size mapping.
        var branding_mapping = googletag.sizeMapping()
        .addSize([1900, 0], [[480, 1080], [300, 600]]) //desktop for bigger screens
        .addSize([1200, 0], [[480, 1080], [120, 600], [160, 600]]) //desktop for smaller screens
        .addSize([0, 0], []) //tablet & mobile
        .build();

        // P GPT size mapping.
        var p_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]]) //desktop
        .addSize([469, 0], [[200, 200], [250, 250], [300, 250]]) //tablet
        .addSize([0, 0], [[200, 200], [250, 250], [300, 250], [336, 280]]) //mobile
        .build();

        // P5 & P6 GPT size mapping.
        var p5_p6_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[200, 200], [250, 250], [300, 250]]) //desktop
        .addSize([469, 0], [[200, 200], [250, 250], [300, 250]]) //tablet
        .addSize([0, 0], [[200, 200], [250, 250], [300, 250], [336, 280]]) //mobile
        .build();

        // InText GPT size mapping.
        var inText_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[580, 280], [200, 200], [250, 250], [300, 250], [320, 250], [320, 240], [336, 280], 'fluid']) //desktop
        .addSize([469, 0], [[300, 50], [320, 50], [468, 60], [200, 200], [250, 250], [300, 250], [320, 250], [320, 240], [336, 280], 'fluid']) //tablet
        .addSize([0, 0], [[300, 50], [300, 75], [320, 80], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [320, 250], [320, 240], [336, 280], 'fluid']) //mobile
        .build();

        // Billboard2_Homepage GPT size mapping.
        var billboard2_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[728, 90], [900, 250], 'fluid']) //desktop
        .addSize([0, 0], [[320, 100], [360, 120], [360, 100], 'fluid']) //mobile
        .build();

        adContainers.forEach(function(el) { // Runs through all of the wrapperAd divs.

            if (!el || !el.id || isGptSlotAlreadyDefined(el.id)) {
                return;
            }

            // **************** Sticky GPT and Prebid definition. *******************

            if (el.id === 'Adhesion' && !isAdSlotDestroyed('Adhesion')) { // Check if Adhesion div is present in body. 

                // Sticky ad unit definition
                Adhesion = googletag.defineSlot(adUnitPath + 'Sticky', [[728, 90], [970, 90]], 'Adhesion')
                                    .defineSizeMapping(sticky_mapping)
                                    .setTargeting('position', 'Adhesion')
                                    .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                                    .addService(googletag.pubads());
                
                // Push the defined Adhesion Prebid placement IDs to the ATF array.      
                adUnitsATF.push(
                    {   code: 'Adhesion',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1600, 0], sizes: [[728, 90], [970, 90], [750, 100], [750, 200], [980, 90], [1000, 100]] }, //desktop for bigger screens (same sizes GPT requests)
                            { minViewPort: [1024, 0], sizes: [[728, 90], [750, 100]] }, //desktop for smaller screens (same sizes GPT requests)
                            { minViewPort: [469, 0], sizes: [[468, 60], [300, 50], [320, 50]] }, //tablet (same sizes GPT requests)
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'adf', params: {mid: '1819281', priceType: 'net'}},
                            {bidder: 'mediapool', params: {mid: '1984189', priceType: 'net'}}, // Mediapool placement for this unit (buys through the Adform platform via the mediapool alias)
                            {bidder: 'connectad', params: {networkId: 44, siteId: 1061412}},
                            {bidder: "eskimi", params: {placementId: 1575}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5536774'}},
                            {bidder: "richaudience", params: {pid: "Ll2Jn1tFRP", supplyType: "site"}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'rubicon', params: {accountId: 19712, siteId: 519960, zoneId: 3127936}},
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            {bidder: 'teads', params: {pageId: 182447, placementId: 197452}},
                            {bidder: "yandex", params: {placementId: 'R-A-6843970-1', cur: 'EUR'}},
                        ]
                    }
                );

            }

            // **************** Billboard GPT and Prebid definition. *******************

            else if (el.id === 'Billboard') { // Check if Billboard div is present in body. 

                // Billboard ad unit definition
                Billboard = googletag.defineSlot(adUnitPath + 'Billboard', [[970, 250]], 'Billboard')
                                     .defineSizeMapping(billboard_mapping)
                                     .setTargeting('position', 'Billboard')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                                     .addService(googletag.pubads());
                
                // Push the defined Billboard Prebid placement IDs to the ATF array.      
                adUnitsATF.push(
                    {   code: 'Billboard',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250], [980, 90], [1000, 100], [980, 250], [990, 250], [1060, 250], [750, 100], [750, 200], [930, 180], [950, 90], [970, 66], [980, 120], [980, 240]] }, //desktop (same sizes GPT requests)
                            { minViewPort: [469, 0], sizes: [[468, 60], [300, 50], [320, 50]] }, //tablet (same sizes GPT requests)
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [300, 75], [320, 80]] }, //mobile (same sizes GPT requests)
                        ]
                        }},
                        bids: [
                            {bidder: 'adf', params: {mid: '1819282', priceType: 'net'}},
                            {bidder: 'mediapool', params: {mid: '1984186', priceType: 'net'}}, // Mediapool placement for this unit (buys through the Adform platform via the mediapool alias)
                            {bidder: 'connectad', params: {networkId: 44, siteId: 1061412}},
                            {bidder: "eskimi", params: {placementId: 1575}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5536775'}},
                            {bidder: "richaudience", params: {pid: "BBiuduBij8", supplyType: "site"}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'rubicon', params: {accountId: 19712, siteId: 519960, zoneId: 3127938}},
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            {bidder: 'teads', params: {pageId: 182447, placementId: 197452}},
                            {bidder: "yandex", params: {placementId: 'R-A-6843970-1', cur: 'EUR'}},
                        ]
                    }
                );

            }

            // **************** Billboard_3 GPT and Prebid definition. *******************

            else if (el.id === 'Billboard_3') { // Check if Billboard_3 div is present in body. 

                // Billboard_3 ad unit definition
                Billboard_3 = googletag.defineSlot(adUnitPath + 'Billboard_3', [[900, 250]], 'Billboard_3')
                                       .defineSizeMapping(billboard2_mapping) // Billboard2_Homepage sizes: the wide Billboard sizes break the layout here.
                                       .setTargeting('position', 'Billboard_3')
                                       .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                                       .addService(googletag.pubads());
                
                // Push the defined Billboard_3 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'Billboard_3',
                        mediaTypes: {banner: {
                        // Same sizes as Billboard2_Homepage (a strict subset of billboard2_mapping above).
                        // The wide Billboard sizes (970px and up) break the page layout in these positions,
                        // so bidders are only offered sizes the slot can render.
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [900, 250]] }, //desktop
                            { minViewPort: [0, 0], sizes: [[320, 100], [360, 120], [360, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'adf', params: {mid: '2279066', priceType: 'net'}},
                            {bidder: 'connectad', params: {networkId: 44, siteId: 1061412}},
                            {bidder: "eskimi", params: {placementId: 1575}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '7735786'}},
                            {bidder: "richaudience", params: {pid: "eGwcL9v4BU", supplyType: "site"}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'rubicon', params: {accountId: 19712, siteId: 519960, zoneId: 4157777}},
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            {bidder: 'teads', params: {pageId: 182447, placementId: 197452}},
                            {bidder: "yandex", params: {placementId: 'R-A-6843970-1', cur: 'EUR'}},
                        ]
                    }
                );

            }
            // **************** Billboard_4 GPT and Prebid definition. *******************

            else if (el.id === 'Billboard_4') { // Check if Billboard_4 div is present in body. 

                // Billboard_4 ad unit definition
                Billboard_4 = googletag.defineSlot(adUnitPath + 'Billboard_4', [[900, 250]], 'Billboard_4')
                                       .defineSizeMapping(billboard2_mapping) // Billboard2_Homepage sizes: the wide Billboard sizes break the layout here.
                                       .setTargeting('position', 'Billboard_4')
                                       .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                                       .addService(googletag.pubads());
                
                // Push the defined Billboard_4 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'Billboard_4',
                        mediaTypes: {banner: {
                        // Same sizes as Billboard2_Homepage (a strict subset of billboard2_mapping above).
                        // The wide Billboard sizes (970px and up) break the page layout in these positions,
                        // so bidders are only offered sizes the slot can render.
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [900, 250]] }, //desktop
                            { minViewPort: [0, 0], sizes: [[320, 100], [360, 120], [360, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'adf', params: {mid: '2279067', priceType: 'net'}},
                            {bidder: 'connectad', params: {networkId: 44, siteId: 1061412}},
                            {bidder: "eskimi", params: {placementId: 1575}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '7735787'}},
                            {bidder: "richaudience", params: {pid: "mNfeGU81E2", supplyType: "site"}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'rubicon', params: {accountId: 19712, siteId: 519960, zoneId: 4157779}},
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            {bidder: 'teads', params: {pageId: 182447, placementId: 197452}},
                            {bidder: "yandex", params: {placementId: 'R-A-6843970-1', cur: 'EUR'}},
                        ]
                    }
                );

            }
            // **************** Billboard_5 GPT and Prebid definition. *******************

            else if (el.id === 'Billboard_5') { // Check if Billboard_5 div is present in body. 

                // Billboard_5 ad unit definition
                Billboard_5 = googletag.defineSlot(adUnitPath + 'Billboard_5', [[900, 250]], 'Billboard_5')
                                       .defineSizeMapping(billboard2_mapping) // Billboard2_Homepage sizes: the wide Billboard sizes break the layout here.
                                       .setTargeting('position', 'Billboard_5')
                                       .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                                       .addService(googletag.pubads());
                
                // Push the defined Billboard_5 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'Billboard_5',
                        mediaTypes: {banner: {
                        // Same sizes as Billboard2_Homepage (a strict subset of billboard2_mapping above).
                        // The wide Billboard sizes (970px and up) break the page layout in these positions,
                        // so bidders are only offered sizes the slot can render.
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [900, 250]] }, //desktop
                            { minViewPort: [0, 0], sizes: [[320, 100], [360, 120], [360, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'adf', params: {mid: '2279068', priceType: 'net'}},
                            {bidder: 'connectad', params: {networkId: 44, siteId: 1061412}},
                            {bidder: "eskimi", params: {placementId: 1575}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '7735788'}},
                            {bidder: "richaudience", params: {pid: "KMsYmP0tEe", supplyType: "site"}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'rubicon', params: {accountId: 19712, siteId: 519960, zoneId: 4157781}},
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            {bidder: 'teads', params: {pageId: 182447, placementId: 197452}},
                            {bidder: "yandex", params: {placementId: 'R-A-6843970-1', cur: 'EUR'}},
                        ]
                    }
                );

            }
            // **************** Billboard_6 GPT and Prebid definition. *******************

            else if (el.id === 'Billboard_6') { // Check if Billboard_6 div is present in body. 

                // Billboard_6 ad unit definition
                Billboard_6 = googletag.defineSlot(adUnitPath + 'Billboard_6', [[900, 250]], 'Billboard_6')
                                       .defineSizeMapping(billboard2_mapping) // Billboard2_Homepage sizes: the wide Billboard sizes break the layout here.
                                       .setTargeting('position', 'Billboard_6')
                                       .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                                       .addService(googletag.pubads());
                
                // Push the defined Billboard_6 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'Billboard_6',
                        mediaTypes: {banner: {
                        // Same sizes as Billboard2_Homepage (a strict subset of billboard2_mapping above).
                        // The wide Billboard sizes (970px and up) break the page layout in these positions,
                        // so bidders are only offered sizes the slot can render.
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [900, 250]] }, //desktop
                            { minViewPort: [0, 0], sizes: [[320, 100], [360, 120], [360, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'adf', params: {mid: '2279069', priceType: 'net'}},
                            {bidder: 'connectad', params: {networkId: 44, siteId: 1061412}},
                            {bidder: "eskimi", params: {placementId: 1575}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '7735789'}},
                            {bidder: "richaudience", params: {pid: "WeUmJrDCQr", supplyType: "site"}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'rubicon', params: {accountId: 19712, siteId: 519960, zoneId: 4157783}},
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            {bidder: 'teads', params: {pageId: 182447, placementId: 197452}},
                            {bidder: "yandex", params: {placementId: 'R-A-6843970-1', cur: 'EUR'}},
                        ]
                    }
                );

            }
            // **************** Billboard_7 GPT and Prebid definition. *******************

            else if (el.id === 'Billboard_7') { // Check if Billboard_7 div is present in body. 

                // Billboard_7 ad unit definition
                Billboard_7 = googletag.defineSlot(adUnitPath + 'Billboard_7', [[900, 250]], 'Billboard_7')
                                       .defineSizeMapping(billboard2_mapping) // Billboard2_Homepage sizes: the wide Billboard sizes break the layout here.
                                       .setTargeting('position', 'Billboard_7')
                                       .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                                       .addService(googletag.pubads());
                
                // Push the defined Billboard_7 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'Billboard_7',
                        mediaTypes: {banner: {
                        // Same sizes as Billboard2_Homepage (a strict subset of billboard2_mapping above).
                        // The wide Billboard sizes (970px and up) break the page layout in these positions,
                        // so bidders are only offered sizes the slot can render.
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [900, 250]] }, //desktop
                            { minViewPort: [0, 0], sizes: [[320, 100], [360, 120], [360, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'adf', params: {mid: '2279070', priceType: 'net'}},
                            {bidder: 'connectad', params: {networkId: 44, siteId: 1061412}},
                            {bidder: "eskimi", params: {placementId: 1575}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '7735790'}},
                            {bidder: "richaudience", params: {pid: "sPfx6Acx8i", supplyType: "site"}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'rubicon', params: {accountId: 19712, siteId: 519960, zoneId: 4157785}},
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            {bidder: 'teads', params: {pageId: 182447, placementId: 197452}},
                            {bidder: "yandex", params: {placementId: 'R-A-6843970-1', cur: 'EUR'}},
                        ]
                    }
                );

            }
            // **************** Branding_Left GPT and Prebid definition. *******************

            else if (el.id === 'Branding_Left' && adWindowWidth > 1599) { // Check if Branding_Left div is present in body. 

                // Branding_Left ad unit definition
                Branding_Left = googletag.defineSlot(adUnitPath + 'Branding_Left', [[480, 1080]], 'Branding_Left')
                                            .defineSizeMapping(branding_mapping)
                                            .setTargeting('position', 'Branding_Left')
                                            .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                                            .addService(googletag.pubads());
                
                // Push the defined Branding_Left Prebid placement IDs to the ATF array.      
                adUnitsATF.push(
                    {   code: 'Branding_Left',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1900, 0], sizes: [[300, 600]] }, //desktop for bigger screens
                            { minViewPort: [1600, 0], sizes: [[120, 600], [160, 600]] }, //desktop for smaller screens
                            { minViewPort: [0, 0], sizes: [] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: "adf", params: { mid: "1819283", priceType: "net" } },
                            { bidder: "connectad", params: { networkId: 44, siteId: 1061412 } },
                            { bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5536776" } },
                            { bidder: "richaudience", params: { pid: "ba22wzu7sz", supplyType: "site" } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 519960, zoneId: 3127940 } },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                        ]
                    }
                );

            }

            // **************** Branding_Right GPT and Prebid definition. *******************

            else if (el.id === 'Branding_Right' && adWindowWidth > 1599) { // Check if Branding_Right div is present in body. 

                // Branding_Right ad unit definition
                Branding_Right = googletag.defineSlot(adUnitPath + 'Branding_Right', [[480, 1080]], 'Branding_Right')
                                            .defineSizeMapping(branding_mapping)
                                            .setTargeting('position', 'Branding_Right')
                                            .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                                            .addService(googletag.pubads());
                
                // Push the defined Branding_Right Prebid placement IDs to the ATF array.      
                adUnitsATF.push(
                    {   code: 'Branding_Right',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1900, 0], sizes: [[300, 600]] }, //desktop for bigger screens
                            { minViewPort: [1600, 0], sizes: [[120, 600], [160, 600]] }, //desktop for smaller screens
                            { minViewPort: [0, 0], sizes: [] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: "adf", params: { mid: "1819284", priceType: "net" } },
                            { bidder: "connectad", params: { networkId: 44, siteId: 1061412 } },
                            { bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5536777" } },
                            { bidder: "richaudience", params: { pid: "TJz6aUVTSv", supplyType: "site" } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 519960, zoneId: 3127942 } },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                        ]
                    }
                );

            }

            // **************** P1 GPT and Prebid definition. *******************

            else if (el.id === 'P1') { // Check if P1 div is present in body. 

                // P1 ad unit definition
                P1 = googletag.defineSlot(adUnitPath + 'P1', [[300, 250]], 'P1')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P1')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                              .addService(googletag.pubads());
                
                // Push the defined P1 Prebid placement IDs to the ATF array.      
                adUnitsATF.push(
                    {   code: 'P1',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'adf', params: {mid: '1819286', priceType: 'net'}},
                            {bidder: 'mediapool', params: {mid: '1984188', priceType: 'net'}}, // Mediapool placement for this unit (buys through the Adform platform via the mediapool alias)
                            {bidder: 'connectad', params: {networkId: 44, siteId: 1061412}},
                            {bidder: "eskimi", params: {placementId: 1575}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5536779'}},
                            {bidder: "richaudience", params: {pid: "uTUg2zIn7d", supplyType: "site"}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'rubicon', params: {accountId: 19712, siteId: 519960, zoneId: 3127946}},
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            {bidder: 'teads', params: {pageId: 182447, placementId: 197452}},
                            {bidder: "yandex", params: {placementId: 'R-A-6843970-1', cur: 'EUR'}},
                        ]
                    }
                );

            }

            // **************** P2 GPT and Prebid definition. *******************

            else if (el.id === 'P2') { // Check if P2 div is present in body. 

                // P2 ad unit definition
                P2 = googletag.defineSlot(adUnitPath + 'P2', [[300, 250]], 'P2')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P2')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                              .addService(googletag.pubads());
                
                // Push the defined P2 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P2',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'adf', params: {mid: '1819287', priceType: 'net'}},
                            {bidder: 'mediapool', params: {mid: '1984187', priceType: 'net'}}, // Mediapool placement for this unit (buys through the Adform platform via the mediapool alias)
                            {bidder: 'connectad', params: {networkId: 44, siteId: 1061412}},
                            {bidder: "eskimi", params: {placementId: 1575}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5536780'}},
                            {bidder: "richaudience", params: {pid: "1inAkleNKM", supplyType: "site"}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'rubicon', params: {accountId: 19712, siteId: 519960, zoneId: 3127948}},
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            {bidder: 'teads', params: {pageId: 182447, placementId: 197452}},
                            {bidder: "yandex", params: {placementId: 'R-A-6843970-1', cur: 'EUR'}},
                        ]
                    }
                );

            }

            // **************** P3 GPT and Prebid definition. *******************

            else if (el.id === 'P3') { // Check if P3 div is present in body. 

                // P3 ad unit definition
                P3 = googletag.defineSlot(adUnitPath + 'P3', [[300, 250]], 'P3')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P3')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                              .addService(googletag.pubads());
                
                // Push the defined P3 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P3',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'adf', params: {mid: '1819288', priceType: 'net'}},
                            {bidder: 'mediapool', params: {mid: '1984209', priceType: 'net'}}, // Mediapool placement for this unit (buys through the Adform platform via the mediapool alias)
                            {bidder: 'connectad', params: {networkId: 44, siteId: 1061412}},
                            {bidder: "eskimi", params: {placementId: 1575}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5536781'}},
                            {bidder: "richaudience", params: {pid: "Cp7oxZP7Sk", supplyType: "site"}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'rubicon', params: {accountId: 19712, siteId: 519960, zoneId: 3127950}},
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            {bidder: 'teads', params: {pageId: 182447, placementId: 197452}},
                            {bidder: "yandex", params: {placementId: 'R-A-6843970-1', cur: 'EUR'}},
                        ]
                    }
                );

            }   

            
            // **************** P4 GPT and Prebid definition. *******************

            else if (el.id === 'P4') { // Check if P4 div is present in body. 

                // P4 ad unit definition
                P4 = googletag.defineSlot(adUnitPath + 'P4', [[300, 250]], 'P4')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P4')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                              .addService(googletag.pubads());
                
                // Push the defined P4 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P4',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: "adf", params: { mid: "1819289", priceType: "net" } },
                            {bidder: 'mediapool', params: {mid: '1984190', priceType: 'net'}}, // Mediapool placement for this unit (buys through the Adform platform via the mediapool alias)
                            { bidder: "connectad", params: { networkId: 44, siteId: 1061412 } },
                            {bidder: "eskimi", params: {placementId: 1575}},
                            { bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5536782" } },
                            { bidder: "richaudience", params: { pid: "8LvU3X7eXh", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 519960, zoneId: 3127952 } },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            { bidder: 'teads', params: { pageId: 182447, placementId: 197452 } },
                            { bidder: "yandex", params: { placementId: 'R-A-6843970-1', cur: 'EUR' } },
                        ]
                    }
                );

            }   

            // **************** P5 GPT and Prebid definition. *******************

            else if (el.id === 'P5') { // Check if P5 div is present in body. 

                // P5 ad unit definition
                P5 = googletag.defineSlot(adUnitPath + 'P5', [[300, 250]], 'P5')
                              .defineSizeMapping(p5_p6_mapping)
                              .setTargeting('position', 'P5')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                              .addService(googletag.pubads());
                
                // Push the defined P5 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P5',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: "adf", params: { mid: "1819290", priceType: "net" } },
                            { bidder: "connectad", params: { networkId: 44, siteId: 1061412 } },
                            {bidder: "eskimi", params: {placementId: 1575}},
                            { bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5536784" } },
                            { bidder: "richaudience", params: { pid: "QyJL0TAgYp", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 519960, zoneId: 3127954 } },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            { bidder: 'teads', params: { pageId: 182447, placementId: 197452 } },
                            { bidder: "yandex", params: { placementId: 'R-A-6843970-1', cur: 'EUR' } },
                        ]
                    }
                );

            }   

            // **************** P6 GPT and Prebid definition. *******************

            else if (el.id === 'P6') { // Check if P6 div is present in body. 

                // P6 ad unit definition
                P6 = googletag.defineSlot(adUnitPath + 'P6', [[300, 250]], 'P6')
                              .defineSizeMapping(p5_p6_mapping)
                              .setTargeting('position', 'P6')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                              .addService(googletag.pubads());
                
                // Push the defined P6 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P6',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: "adf", params: { mid: "1819291", priceType: "net" } },
                            { bidder: "connectad", params: { networkId: 44, siteId: 1061412 } },
                            {bidder: "eskimi", params: {placementId: 1575}},
                            { bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5536785" } },
                            { bidder: "richaudience", params: { pid: "Rz6BzzpiiX", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 519960, zoneId: 3127956 } },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            { bidder: 'teads', params: { pageId: 182447, placementId: 197452 } },
                            { bidder: "yandex", params: { placementId: 'R-A-6843970-1', cur: 'EUR' } },
                        ]
                    }
                );

            }   

            // **************** P7 GPT and Prebid definition. *******************

            else if (el.id === 'P7') { // Check if P7 div is present in body. 

                // P7 ad unit definition
                P7 = googletag.defineSlot(adUnitPath + 'P7', [[300, 250]], 'P7')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P7')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                              .addService(googletag.pubads());
                
                // Push the defined P7 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P7',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: "adf", params: { mid: "1819292", priceType: "net" } },
                            { bidder: "connectad", params: { networkId: 44, siteId: 1061412 } },
                            {bidder: "eskimi", params: {placementId: 1575}},
                            { bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5536786" } },
                            { bidder: "richaudience", params: { pid: "BjRuDetLvc", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 519960, zoneId: 3127960 } },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            { bidder: 'teads', params: { pageId: 182447, placementId: 197452 } },
                            { bidder: "yandex", params: { placementId: 'R-A-6843970-1', cur: 'EUR' } },
                        ]
                    }
                );

            }   

            // **************** P8 GPT and Prebid definition. *******************

            else if (el.id === 'P8') { // Check if P8 div is present in body. 

                // P8 ad unit definition
                P8 = googletag.defineSlot(adUnitPath + 'P8', [[300, 250]], 'P8')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P8')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                              .addService(googletag.pubads());
                
                // Push the defined P8 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P8',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: "adf", params: { mid: "1819293", priceType: "net" } },
                            { bidder: "connectad", params: { networkId: 44, siteId: 1061412 } },
                            {bidder: "eskimi", params: {placementId: 1575}},
                            { bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5536787" } },
                            { bidder: "richaudience", params: { pid: "npBF39i4Lo", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 519960, zoneId: 3127962 } },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            { bidder: 'teads', params: { pageId: 182447, placementId: 197452 } },
                            { bidder: "yandex", params: { placementId: 'R-A-6843970-1', cur: 'EUR' } },
                        ]
                    }
                );

            }  

            // **************** P9 GPT and Prebid definition. *******************

            else if (el.id === 'P9') { // Check if P9 div is present in body. 

                // P9 ad unit definition
                P9 = googletag.defineSlot(adUnitPath + 'P9', [[300, 250]], 'P9')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P9')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                              .addService(googletag.pubads());
                
                // Push the defined P9 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P9',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: "adf", params: { mid: "1819294", priceType: "net" } },
                            { bidder: "connectad", params: { networkId: 44, siteId: 1061412 } },
                            {bidder: "eskimi", params: {placementId: 1575}},
                            { bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5536788" } },
                            { bidder: "richaudience", params: { pid: "aDJTpmoSUb", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 519960, zoneId: 3127964 } },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            { bidder: 'teads', params: { pageId: 182447, placementId: 197452 } },
                            { bidder: "yandex", params: { placementId: 'R-A-6843970-1', cur: 'EUR' } },
                        ]
                    }
                );

            }   

            // **************** P10 GPT and Prebid definition. *******************

            else if (el.id === 'P10') { // Check if P10 div is present in body. 

                // P10 ad unit definition
                P10 = googletag.defineSlot(adUnitPath + 'P10', [[300, 250]], 'P10')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P10')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                              .addService(googletag.pubads());
                
                // Push the defined P10 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P10',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: "adf", params: { mid: "1819295", priceType: "net" } },
                            { bidder: "connectad", params: { networkId: 44, siteId: 1061412 } },
                            {bidder: "eskimi", params: {placementId: 1575}},
                            { bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5536789" } },
                            { bidder: "richaudience", params: { pid: "fCaF5CXjvm", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 519960, zoneId: 3127966 } },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            { bidder: 'teads', params: { pageId: 182447, placementId: 197452 } },
                            { bidder: "yandex", params: { placementId: 'R-A-6843970-1', cur: 'EUR' } },
                        ]
                    }
                );

            }   

            // **************** P11 GPT and Prebid definition. *******************

            else if (el.id === 'P11') { // Check if P11 div is present in body. 

                // P11 ad unit definition
                P11 = googletag.defineSlot(adUnitPath + 'P11', [[300, 250]], 'P11')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P11')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                              .addService(googletag.pubads());
                
                // Push the defined P11 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P11',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: "adf", params: { mid: "1819296", priceType: "net" } },
                            { bidder: "connectad", params: { networkId: 44, siteId: 1061412 } },
                            {bidder: "eskimi", params: {placementId: 1575}},
                            { bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5536790" } },
                            { bidder: "richaudience", params: { pid: "hGxlIB1Sqw", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 519960, zoneId: 3127968 } },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            { bidder: 'teads', params: { pageId: 182447, placementId: 197452 } },
                            { bidder: "yandex", params: { placementId: 'R-A-6843970-1', cur: 'EUR' } },
                        ]
                    }
                );

            }   

            // **************** P12 GPT and Prebid definition. *******************

            else if (el.id === 'P12') { // Check if P12 div is present in body. 

                // P12 ad unit definition
                P12 = googletag.defineSlot(adUnitPath + 'P12', [[300, 250]], 'P12')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P12')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                              .addService(googletag.pubads());
                
                // Push the defined P12 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P12',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: "adf", params: { mid: "1819297", priceType: "net" } },
                            { bidder: "connectad", params: { networkId: 44, siteId: 1061412 } },
                            {bidder: "eskimi", params: {placementId: 1575}},
                            { bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5536791" } },
                            { bidder: "richaudience", params: { pid: "C8n2rOhAxq", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 519960, zoneId: 3127970 } },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            { bidder: 'teads', params: { pageId: 182447, placementId: 197452 } },
                            { bidder: "yandex", params: { placementId: 'R-A-6843970-1', cur: 'EUR' } },
                        ]
                    }
                );

            }   

            // **************** InText_1 GPT and Prebid definition. *******************

            else if (el.id === 'InText_1') { // Check if InText_1 div is present in body. 

                // InText_1 ad unit definition
                InText_1 = googletag.defineSlot(adUnitPath + 'InText_1', [[300, 250]], 'InText_1')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'InText_1')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                                     .addService(googletag.pubads());
                
                // Push the defined InText_1 Prebid placement IDs to the ATF array.      
                adUnitsATF.push(
                    {   code: 'InText_1',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280], [580, 250], [580, 280], [320, 240], [320, 250]] }, //desktop (same sizes GPT requests)
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50], [320, 240], [320, 250]] }, //tablet (same sizes GPT requests)
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280], [300, 75], [320, 80], [320, 240], [320, 250]] }, //mobile (same sizes GPT requests)
                        ]
                        }},
                        bids: [
                            { bidder: 'adf', params: {mid: '1819298', priceType: 'net'} },
                            {bidder: 'mediapool', params: {mid: '1984198', priceType: 'net'}}, // Mediapool placement for this unit (buys through the Adform platform via the mediapool alias)
                            { bidder: 'connectad', params: {networkId: 44, siteId: 1061412} },
                            {bidder: "eskimi", params: {placementId: 1575}},
                            { bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5536792'} },
                            { bidder: "richaudience", params: { pid: "AI37xk2g5o", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: 'rubicon', params: {accountId: 19712, siteId: 519960, zoneId: 3127972} },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            { bidder: 'teads', params: {pageId: 182448, placementId: 197453} },
                            { bidder: "yandex", params: { placementId: 'R-A-6843970-1', cur: 'EUR' } },
                        ]
                    }
                );

            }   

            // **************** InText_2 GPT and Prebid definition. *******************

            else if (el.id === 'InText_2') { // Check if InText_2 div is present in body. 

                // InText_2 ad unit definition
                InText_2 = googletag.defineSlot(adUnitPath + 'InText_2', [[300, 250]], 'InText_2')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'InText_2')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                                     .addService(googletag.pubads());
                
                // Push the defined InText_2 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'InText_2',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280], [580, 250], [580, 280], [320, 240], [320, 250]] }, //desktop (same sizes GPT requests)
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50], [320, 240], [320, 250]] }, //tablet (same sizes GPT requests)
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280], [300, 75], [320, 80], [320, 240], [320, 250]] }, //mobile (same sizes GPT requests)
                        ]
                        }},
                        bids: [
                            { bidder: 'adf', params: {mid: '1819299', priceType: 'net'} },
                            {bidder: 'mediapool', params: {mid: '1984208', priceType: 'net'}}, // Mediapool placement for this unit (buys through the Adform platform via the mediapool alias)
                            { bidder: 'connectad', params: {networkId: 44, siteId: 1061412} },
                            {bidder: "eskimi", params: {placementId: 1575}},
                            { bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5536793'}} ,
                            { bidder: "richaudience", params: { pid: "xOoYbFG2TQ", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: 'rubicon', params: {accountId: 19712, siteId: 519960, zoneId: 3127974} },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            { bidder: 'teads', params: {pageId: 182448, placementId: 197453} },
                            { bidder: "yandex", params: { placementId: 'R-A-6843970-1', cur: 'EUR' } },
                        ]
                    }
                );

            }   

            // **************** InText_3 GPT and Prebid definition. *******************

            else if (el.id === 'InText_3') { // Check if InText_3 div is present in body. 

                // InText_3 ad unit definition
                InText_3 = googletag.defineSlot(adUnitPath + 'InText_3', [[300, 250]], 'InText_3')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'InText_3')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                                     .addService(googletag.pubads());
                
                // Push the defined InText_3 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'InText_3',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280], [580, 250], [580, 280], [320, 240], [320, 250]] }, //desktop (same sizes GPT requests)
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50], [320, 240], [320, 250]] }, //tablet (same sizes GPT requests)
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280], [300, 75], [320, 80], [320, 240], [320, 250]] }, //mobile (same sizes GPT requests)
                        ]
                        }},
                        bids: [
                            { bidder: 'adf', params: {mid: '1819300', priceType: 'net'} },
                            {bidder: 'mediapool', params: {mid: '1984205', priceType: 'net'}}, // Mediapool placement for this unit (buys through the Adform platform via the mediapool alias)
                            { bidder: 'connectad', params: {networkId: 44, siteId: 1061412} },
                            {bidder: "eskimi", params: {placementId: 1575}},
                            { bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5536794'} },
                            { bidder: "richaudience", params: { pid: "KCYuaF4GfD", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: 'rubicon', params: {accountId: 19712, siteId: 519960, zoneId: 3127976} },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            { bidder: 'teads', params: {pageId: 182448, placementId: 197453} },
                            { bidder: "yandex", params: { placementId: 'R-A-6843970-1', cur: 'EUR' } },
                        ]
                    }
                );

            }  

            // **************** InText_4 GPT and Prebid definition. *******************

            else if (el.id === 'InText_4') { // Check if InText_4 div is present in body. 

                // InText_4 ad unit definition
                InText_4 = googletag.defineSlot(adUnitPath + 'InText_4', [[300, 250]], 'InText_4')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'InText_4')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                                     .addService(googletag.pubads());
                
                // Push the defined InText_4 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'InText_4',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280], [580, 250], [580, 280], [320, 240], [320, 250]] }, //desktop (same sizes GPT requests)
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50], [320, 240], [320, 250]] }, //tablet (same sizes GPT requests)
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280], [300, 75], [320, 80], [320, 240], [320, 250]] }, //mobile (same sizes GPT requests)
                        ]
                        }},
                        bids: [
                            { bidder: "adf", params: { mid: "1819301", priceType: "net" } },
                            {bidder: 'mediapool', params: {mid: '1984203', priceType: 'net'}}, // Mediapool placement for this unit (buys through the Adform platform via the mediapool alias)
                            { bidder: "connectad", params: { networkId: 44, siteId: 1061412 } },
                            {bidder: "eskimi", params: {placementId: 1575}},
                            { bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5536795" } },
                            { bidder: "richaudience", params: { pid: "xnfoIwEbHN", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 519960, zoneId: 3127978 } },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            { bidder: 'teads', params: {pageId: 182448, placementId: 197453} },
                            { bidder: "yandex", params: { placementId: 'R-A-6843970-1', cur: 'EUR' } },
                        ]
                    }
                );

            }  

            // **************** InText_5 GPT and Prebid definition. *******************

            else if (el.id === 'InText_5') { // Check if InText_5 div is present in body. 

                // InText_5 ad unit definition
                InText_5 = googletag.defineSlot(adUnitPath + 'InText_5', [[300, 250]], 'InText_5')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'InText_5')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                                     .addService(googletag.pubads());
                
                // Push the defined InText_5 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'InText_5',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280], [580, 250], [580, 280], [320, 240], [320, 250]] }, //desktop (same sizes GPT requests)
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50], [320, 240], [320, 250]] }, //tablet (same sizes GPT requests)
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280], [300, 75], [320, 80], [320, 240], [320, 250]] }, //mobile (same sizes GPT requests)
                        ]
                        }},
                        bids: [
                            { bidder: "adf", params: { mid: "1819302", priceType: "net" } },
                            { bidder: "connectad", params: { networkId: 44, siteId: 1061412 } },
                            {bidder: "eskimi", params: {placementId: 1575}},
                            { bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5536796" } },
                            { bidder: "richaudience", params: { pid: "1RIWBp4IS5", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 519960, zoneId: 3127980 } },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            { bidder: 'teads', params: {pageId: 182448, placementId: 197453} },
                            { bidder: "yandex", params: { placementId: 'R-A-6843970-1', cur: 'EUR' } },
                        ]
                    }
                );

            }  

            // **************** Citulje_P1 GPT definition. *******************

            else if (el.id === 'Citulje_P1') { // Check if Citulje_P1 div is present in body. 

                // Citulje_P1 ad unit definition
                Citulje_P1 = googletag.defineSlot('/34670701/citulje.novosti.rs/P1', [[300, 250]], 'Citulje_P1')
                                     .setTargeting('position', 'citulje')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                                     .addService(googletag.pubads());
            }  

            // **************** Billboard2_Homepage GPT and Prebid definition. *******************

            else if (el.id === 'Billboard2_Homepage') { // Check if Billboard2_Homepage div is present in body. 

                // Billboard2_Homepage ad unit definition
                Billboard2_Homepage = googletag.defineSlot(adUnitPath + 'Billboard2_Homepage', [[900, 250]], 'Billboard2_Homepage')
                                     .defineSizeMapping(billboard2_mapping)
                                     .setTargeting('position', 'Billboard2_Homepage')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', 'initial')
                                     .addService(googletag.pubads());

                // Push the defined Billboard2_Homepage Prebid placement IDs to the BTF array.
                // This slot is below the fold on the homepage and its div carries the lazyAd class,
                // so it belongs in the BTF array and is auctioned by the IntersectionObserver rather
                // than in the initial auction.
                adUnitsBTF.push(
                    {   code: 'Billboard2_Homepage',
                        mediaTypes: {banner: {
                        // These sizes are deliberately a subset of billboard2_mapping above. A bid for a
                        // size the GPT slot does not accept would win the auction and then fail to render,
                        // so only sizes present in the slot's own size mapping are offered to the bidders.
                        // The 'fluid' entry in the GPT mapping is intentionally omitted, as Prebid banner
                        // bidders cannot bid on it.
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [900, 250]] }, //desktop
                            { minViewPort: [0, 0], sizes: [[320, 100], [360, 120], [360, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                            // Per-unit placement IDs come from the "Billboard_2" row of the Novosti HB
                            // sheet, which was provisioned for this slot but never wired up. They are
                            // deliberately NOT copied from the Billboard unit, so that this slot reports
                            // separately on the SSP side.
                            {bidder: 'adf', params: {mid: '2279065', priceType: 'net'}},
                            {bidder: 'connectad', params: {networkId: 44, siteId: 1061412}},
                            {bidder: "eskimi", params: {placementId: 1575}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '7735784'}},
                            {bidder: "richaudience", params: {pid: "hUvgcX5WS9", supplyType: "site"}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'rubicon', params: {accountId: 19712, siteId: 519960, zoneId: 4157775}},
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wd-hb-stdb-novost-ringi-r6mnizqd9rfi' }, labelAny: ['desktop'] },
                            { bidder: 'ogury', params: { assetKey: 'OGY-51B5ACF071BF', adUnitId: 'wm-hb-stdb-novost-ringi-4tnuapdpmrkn' }, labelAny: ['mobile'] },
                            {bidder: 'teads', params: {pageId: 182447, placementId: 197452}},
                            {bidder: "yandex", params: {placementId: 'R-A-6843970-1', cur: 'EUR'}},
                        ]
                    }
                );

            }  

        }); // End of wrapperAd divs check. 

        //Create sticky ad once the ad is ready to render
        googletag.pubads().addEventListener('slotRenderEnded', function(event) {

            let unitPath = event.slot.getAdUnitPath(); //get the ad unith path for the slot which will render the ad
            let stickyBackground = document.getElementById('adhesion_background'); //get the adhesion background id
            //let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth; //check user's screen width

            if (unitPath === adUnitPath + "Sticky" && event.isEmpty === true) {
                let sticky = document.getElementById('Adhesion');
                sticky.style.display = 'none';
            }

            // if ad unit is sticky and the background is not set, set sticky CSS for sticky ad unit
            else if (unitPath === adUnitPath + "Sticky" && stickyBackground === null){
            let sticky = document.getElementById('Adhesion');
            sticky.style.position = 'fixed';
            sticky.style.zIndex = '999999';
            sticky.style.width = '100%';
            sticky.style.height = '';
            sticky.style.bottom = '0px';
            sticky.style.textAlign = 'center';	
            sticky.style.padding = '10px 0px 0px';
            sticky.style.borderTop = '1px #CCC solid';
            
            // create adhesion background
            let background = document.createElement("div");
            background.setAttribute("ID", "adhesion_background");
            background.style.backgroundColor = '#FFF';
            
            if (adWindowWidth > 1024) {
                background.style.opacity = '70%';
            }

            else {
                background.style.opacity = '100%';
            }

            background.style.position = 'absolute';
            background.style.height = '100%';
            background.style.width = '100%';
            background.style.top = '0';
            background.style.left = '0';
            background.style.zIndex = '-1';
            sticky.appendChild(background);

            // create placeholder text
            /*let placeholder = document.createElement("div");
            placeholder.setAttribute("ID", "adText");
            placeholder.style.textAlign = 'center';
            placeholder.style.fontSize = '10px';
            placeholder.style.color = '#CCC';
            placeholder.style.height = '20px';
            placeholder.style.borderTop = '1px #CCC solid';
            placeholder.style.paddingTop = '2px';
            placeholder.textContent = 'Oglas'
            background.appendChild(placeholder);*/
        
            // create close button with svg elements
            let closeButton = document.createElement("div");
            closeButton.setAttribute("ID", "close_adhesion")
            closeButton.style.position = 'absolute';
            closeButton.style.top = '-29px';
            closeButton.style.right = '0px';
            closeButton.style.cursor = 'pointer';
            closeButton.style.padding = '8px';
            //closeButton.style.borderRadius = '50%';
            closeButton.style.border = '1px solid #CCC';
            //closeButton.style.boxShadow = '0 0 3px #b8b9be';
            closeButton.style.background = '#FFF';
            closeButton.style.borderBottom = '1px solid #FFF';
            closeButton.style.borderTopLeftRadius = '10px';
            
            let iconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            let iconPath = document.createElementNS(
                'http://www.w3.org/2000/svg',
                'path'
            );

            iconSvg.setAttribute('display', 'block');
            iconSvg.setAttribute('fill', '#000');
            iconSvg.setAttribute('width', '12px');
            iconSvg.setAttribute('height', '12px');
            iconSvg.setAttribute('viewBox', '0 0 8 8');

            iconPath.setAttribute(
                'd',
                'M1.41 0l-1.41 1.41.72.72 1.78 1.81-1.78 1.78-.72.69 1.41 1.44.72-.72 1.81-1.81 1.78 1.81.69.72 1.44-1.44-.72-.69-1.81-1.78 1.81-1.81.72-.72-1.44-1.41-.69.72-1.78 1.78-1.81-1.78-.72-.72z'
            );
            
            iconSvg.appendChild(iconPath);
            closeButton.appendChild(iconSvg); 
            sticky.appendChild(closeButton);
            
            // when user clicks the close button, remove the sticky div
            document.getElementById("close_adhesion").addEventListener('click', function(e) {
                e.preventDefault();
                sticky.parentNode.removeChild(sticky);
            }, false); 


            } 
        });
        
        // Check if adsKeywords object is present
        if (typeof adsKeywords != 'undefined') {

            // Check if adsKeywords attributes are present, if so, pass them as key values to GAM
            if (typeof adsKeywords.category != 'undefined') {
                googletag.pubads().setTargeting('category', adsKeywords.category);
            } 

            if (typeof adsKeywords.subcategory != 'undefined') {
                googletag.pubads().setTargeting('subcategory', adsKeywords.subcategory);
            } 

            if (typeof adsKeywords.pageType != 'undefined') {
                googletag.pubads().setTargeting('pageType', adsKeywords.pageType);
            } 

            if (typeof adsKeywords.articleId != 'undefined') {
                googletag.pubads().setTargeting('articleId', [adsKeywords.articleId].join(','));
            } 
            
            if (typeof adsKeywords.articleTags != 'undefined') {
                googletag.pubads().setTargeting('articleTags', [adsKeywords.articleTags].join(','));
            } 
        }

        let adQueryString = window.location.search; // Get the whole string in the URL. 
        //console.log("Query string is " + adQueryString);

        let adUrlParams = new URLSearchParams(adQueryString); // Get the information after ? in the URL. 
        //console.log("URL param is " +  adUrlParams);

        if (adUrlParams.has('adTest')) { 
            let adValue = adUrlParams.get('adTest'); // If there is a adTest param get the value after =. 
            //console.log("AdTest value is " + adValue);
            googletag.pubads().setTargeting('adTest', adValue); // Send the adTest value to GAM.
        } 

        googletag.pubads().disableInitialLoad(); // Disables requests for ads on page load. 
        googletag.pubads().enableSingleRequest(); // Enables single request mode for fetching multiple ads at the same time.
        googletag.enableServices(); // Enables all GPT services that have been defined for ad slots on the page.

        // Get the list of slots associated with this service.
        googletag.pubads().getSlots().forEach(function(adSlots) {
            googletag.display(adSlots.getSlotElementId()); // Instructs slot services to render all of the defined ad slots. 
        });

        // GPT slots and Prebid ad unit arrays are now built, so it is safe to start auctions and observers.
        startInitialPrebidAuction();
        setupBtfAndRefreshObservers();

    });

    function startInitialPrebidAuction() {
        pbjs.que.push(function() {
        // Mediapool buys through the Adform platform, so its placements run on the adf adapter under their
        // own bidder code. The alias keeps Mediapool's bids separate in reporting and sends its placements in
        // a request of their own, independent of the adf placements (Adform validates ads.txt per request).
        pbjs.aliasBidder('adf', 'mediapool', { gvlid: 50 });

        pbjs.setConfig({
    
            priceGranularity: 'high', //$0.01 increments, up to $20

            // Device labels used for bidder-level desktop/mobile targeting.
            sizeConfig: [
                {
                    mediaQuery: '(min-width: 1024px)',
                    labels: ['desktop']
                },
                {
                    mediaQuery: '(max-width: 1023px)',
                    labels: ['mobile']
                }
            ],

            enableSendAllBids: false, //send only top bids
            targetingControls: {
              alwaysIncludeDeals: true //send all deal bids
            },
    
            //Currency module
            currency: {
                "adServerCurrency": "EUR",
                "conversionRateFile": "https://cdn.jsdelivr.net/gh/prebid/currency-file@1/latest.json",
             },
    
            //Coockie match and user syncs
            userSync: {
                syncEnabled: true,
                syncsPerBidder: 5,
                syncDelay: 3000,
                userIds: [
    
                    { name: "sharedId", 
                      storage: { type: "cookie", name: "_sharedid", expires: 365 } 
                    },
    
                    { name: "id5Id",
                      params: { partner: 1355, externalModuleUrl: 'https://cdn.id5-sync.com/api/1.0/id5PrebidModule.js' },
                      storage: { type: "html5", name: "id5id", expires: 90, refreshInSeconds: 8*3600 }
                    },
    
                    { name: 'teadsId',
                      params: { pubId: 26849 }
                    },
    
                    /*{ name: 'criteo',
                    },*/
    
                    { name: 'lotamePanoramaId',
                    },
    
                ],
                // Do not delay the auction for Lotame or any other user ID module.
                // IDs can still be used if already available, but the auction starts immediately.
                auctionDelay: 0,
                aliasSyncEnabled: true,
                filterSettings: { all: { bidders: "*", filter: "include" } },
            },

            enableTIDs: true,

            consentManagement: {
                gdpr: {
                  cmpApi: 'iab',
                  // Wait for the CMP's final answer for up to CONSENT_TIMEOUT_MS before the first auction.
                  // GPT holds its own ad requests until the CMP answers, so a short Prebid consent timeout
                  // bought no speed: it only started the first auction without consent data, and the
                  // enforcement module then dropped every bidder from that auction.
                  timeout: CONSENT_TIMEOUT_MS,
                  // When the CMP gives no answer inside the timeout, treat the visit as outside the GDPR
                  // scope (the audience is almost entirely non-EEA) instead of as GDPR-without-consent,
                  // which would again strip every bidder from the auction.
                  defaultGdprScope: false
                }
            },

            //useBidCache: true,

            // No schain config: the Prebid schain module is deprecated (Prebid 10+) and this wrapper no longer
            // declares a supply chain. If one is wanted again it belongs in ortb2.source.schain (first-party data).
        });

        pbjs.bidderSettings = {
            standard: {
                storageAllowed: true,
            },
        }; 
        
        
        //Add only ATF ad units.
        pbjs.addAdUnits(adUnitsATF);
        
        //Request bids. If Prebid or any optional async module stalls, initAdserver fallback below still refreshes GPT.
        try {
            pbjs.requestBids({ labels: PREBID_LABELS, bidsBackHandler: initAdserver,
                timeout: PREBID_TIMEOUT
            });
        } catch (err) {
            // Initial Prebid request failed, but GPT refresh must still continue through the fallback.
            initAdserver();
        }
    });

        // Non-blocking initial GPT fallback. Ads must not wait forever for Prebid, IDs, consent enrichment, or any optional async dependency.
        // The timer starts counting once consent is final (see startInitialAdserverFailsafe) and has an absolute ceiling.
        startInitialAdserverFailsafe();
    }

    function getSlotByElementId(slotId) {
        var matchedSlot = null;
        googletag.pubads().getSlots().forEach(function(slot) {
            if (slot.getSlotElementId() === slotId) {
                matchedSlot = slot;
            }
        });
        return matchedSlot;
    }

    function getInitialSlots() {
        return [Adhesion, Billboard, Branding_Left, Branding_Right, P1, InText_1].filter(function(slot) {
            return !!slot && !isAdSlotDestroyed(slot.getSlotElementId());
        });
    }

    function refreshGPTSlots(slots) {
        var validSlots = (slots || []).filter(function(slot) {
            return !!slot && slot.getSlotElementId && !isAdSlotDestroyed(slot.getSlotElementId());
        });

        if (validSlots.length) {
            googletag.pubads().refresh(validSlots);
        }
    }

    function setPrebidTargetingSafe(adUnitCodes) {
        try {
            if (window.pbjs && typeof pbjs.setTargetingForGPTAsync === 'function') {
                pbjs.setTargetingForGPTAsync(adUnitCodes);
            }
        } catch (err) {
            // Prebid targeting is optional. GPT refresh must continue.
        }
    }

    function requestBidsWithFallback(adUnitCodes, slots, doneCallback) {
        var completed = false;

        function finish() {
            if (completed) return;
            completed = true;
            clearTimeout(fallbackTimer);

            var activeAdUnitCodes = (adUnitCodes || []).filter(function(code) {
                return !isAdSlotDestroyed(code);
            });
            var activeSlots = (slots || []).filter(function(slot) {
                return slot && slot.getSlotElementId && !isAdSlotDestroyed(slot.getSlotElementId());
            });

            if (activeAdUnitCodes.length) {
                setPrebidTargetingSafe(activeAdUnitCodes);
            }

            if (typeof doneCallback === 'function') {
                doneCallback();
            } else {
                refreshGPTSlots(activeSlots);
            }
        }

        var fallbackTimer = setTimeout(finish, PREBID_TIMEOUT + 300);

        try {
            var requestableAdUnitCodes = (adUnitCodes || []).filter(function(code) {
                return !isAdSlotDestroyed(code);
            });

            if (!requestableAdUnitCodes.length) {
                finish();
            } else if (window.pbjs && typeof pbjs.requestBids === 'function') {
                pbjs.requestBids({ labels: PREBID_LABELS, timeout: PREBID_TIMEOUT,
                    adUnitCodes: requestableAdUnitCodes,
                    bidsBackHandler: finish
                });
            } else {
                finish();
            }
        } catch (err) {
            finish();
        }
    }

    function getRefreshBucket(refreshCount) {
        if (refreshCount <= 0) return 'initial';
        if (refreshCount === 1) return '1';
        if (refreshCount === 2) return '2';
        if (refreshCount === 3) return '3';
        if (refreshCount <= 5) return '4_5';
        if (refreshCount <= 10) return '6_10';
        if (refreshCount <= 20) return '11_20';
        return '21_plus';
    }

    function getSlotRefreshDelay(divId) {
        return GAM_FAST_REFRESH_ADUNITS.includes(divId) ? SECONDS_TO_WAIT_AFTER_VIEWABILITY_FAST : SECONDS_TO_WAIT_AFTER_VIEWABILITY;
    }

    // ---- Consent-aware failsafe for the initial GPT request ----
    // The initial Prebid auction is held by Prebid's consent module until the CMP gives its final answer
    // (at most CONSENT_TIMEOUT_MS). A fixed failsafe counted from script start would fire before such a
    // held auction returns and send the first GPT request without any Prebid bids, wasting the whole first
    // auction. The failsafe below therefore starts counting only once consent is final, and a separate
    // absolute ceiling still guarantees that the initial GPT request is never held forever.
    // Timing constants live at the top of the file (INITIAL_ADSERVER_FAILSAFE_MS / INITIAL_ADSERVER_CEILING_MS):
    // they must be assigned before the GPT command queue runs the callback that calls startInitialAdserverFailsafe().
    // A CMP answer counts as final when it says GDPR does not apply, or when the TC string is final.
    function isFinalConsentAnswer(tcData) {
        if (!tcData) {
            return false;
        }
        if (tcData.gdprApplies === false) {
            return true;
        }
        if (tcData.eventStatus === 'tcloaded') {
            return true;
        }
        if (tcData.eventStatus === 'useractioncomplete') {
            return true;
        }
        return false;
    }
    // Arms the PREBID_TIMEOUT + 500 ms failsafe exactly once and records why it was armed (debugging aid).
    function armInitialAdserverFailsafe(reason) {
        if (initialAdserverFailsafeArmed) {
            return;
        }
        initialAdserverFailsafeArmed = true;
        window.adsInitialFailsafeReason = reason;
        setTimeout(initAdserver, INITIAL_ADSERVER_FAILSAFE_MS);
    }
    function startInitialAdserverFailsafe() {
        // Absolute ceiling: whatever the CMP does, the initial GPT request is sent by this point.
        setTimeout(initAdserver, INITIAL_ADSERVER_CEILING_MS);
        // Without a TCF API on the page Prebid does not wait for consent, so arm the failsafe right away.
        if (typeof window.__tcfapi !== 'function') {
            armInitialAdserverFailsafe('no_tcf_api');
            return;
        }
        try {
            window.__tcfapi('addEventListener', 2, function(tcData, success) {
                if (success === false) {
                    return;
                }
                if (!isFinalConsentAnswer(tcData)) {
                    return;
                }
                armInitialAdserverFailsafe('consent_final');
                // The listener has done its job; detach it when the CMP reports a listener id.
                if (typeof tcData.listenerId !== 'undefined' && tcData.listenerId !== null) {
                    try {
                        window.__tcfapi('removeEventListener', 2, function() {}, tcData.listenerId);
                    } catch (removeErr) {
                        // Detaching is optional; a CMP that refuses it simply keeps calling an armed no-op.
                    }
                }
            });
        } catch (err) {
            // A broken TCF API must not leave the page without ads; fall back to the plain timer.
            armInitialAdserverFailsafe('tcf_api_error');
        }
    }
    // Send requests to the SSPs and send bids to GAM for the ATF slots.
    function initAdserver() {
        if (pbjs.initAdserverSet) return;
        pbjs.initAdserverSet = true;
        googletag.cmd.push(function() {
            setPrebidTargetingSafe();
            refreshGPTSlots(getInitialSlots());
        });
    }

    function setupBtfAndRefreshObservers() {

        //Add BTF ad units.
        pbjs.que.push(function() {
        pbjs.addAdUnits(adUnitsBTF);
    });

    // Use IntersectionObserver API to check whether an ad slot is at the certain distance.
    var observer = new IntersectionObserver(function(entries) {

        entries.forEach(function(entry) {

            if (entry.isIntersecting) {

                var adSlot = entry.target.id;
                if (isAdSlotDestroyed(adSlot)) {
                    observer.unobserve(entry.target);
                    return;
                }
                var gptSlot = getSlotByElementId(adSlot);

                requestBidsWithFallback([adSlot], [gptSlot]);
                observer.unobserve(entry.target);
            }
        });
    }, {rootMargin: DISTANCE_IN_PIXELS_FOR_LAZY_LOADING});

    document.querySelectorAll('.lazyAd').forEach(function(slots) {
        observer.observe(slots);
    });

    // Get the list of slots associated with this service for the refresh logic.
    googletag.pubads().getSlots().forEach(function(slotAd) {

        var divId = slotAd.getSlotElementId();
        var interval;

        if (isAdSlotDestroyed(divId)) {
            return;
        }

        // Use IntersectionObserver API to check whether an ad slot is viewable for certain percent.
        var viewabilityObserver = new IntersectionObserver(function(viewabilityEntries) {

            viewabilityEntries.forEach(function(viewabilityEntry) {

                var slotId = viewabilityEntry.target.id;

                if (viewabilityEntry.isIntersecting && !isAdSlotDestroyed(divId)) {

                    clearInterval(interval);
                    interval = setInterval(function() {

                        if (isAdSlotDestroyed(divId)) {
                            clearInterval(interval);
                            delete refreshIntervalsBySlotId[divId];
                            return;
                        }

                        var advertiserID;

                        try {
                            var responseInformation = slotAd.getResponseInformation();
                            advertiserID = responseInformation && responseInformation.advertiserId;
                        } catch (err) {
                            // Advertiser ID is optional. Refresh decision must continue safely.
                        }

                        if (!GAM_NOREFRESH_ADVERTISER_IDS.includes(advertiserID) && !GAM_NOREFRESH_ADUNITS.includes(divId) && document.visibilityState === 'visible') {
                            var currentRefreshCount = parseInt(slotAd.getTargeting('refresh_count')[0] || '0', 10);
                            var nextRefreshCount = currentRefreshCount + 1;

                            slotAd.setTargeting('refresh_count', String(nextRefreshCount));
                            slotAd.setTargeting('refresh_bucket', getRefreshBucket(nextRefreshCount));

                            requestBidsWithFallback([slotId], [slotAd]);
                        }

                    }, getSlotRefreshDelay(divId) * 1000);
                    refreshIntervalsBySlotId[divId] = interval;
                } else {
                    clearInterval(interval);
                    delete refreshIntervalsBySlotId[divId];
                }
            });

        }, {threshold: VISIBILITY_PERCENT_FOR_REFRESH});

        refreshObserversBySlotId[divId] = viewabilityObserver;

        document.querySelectorAll('#' + divId).forEach(function(viewabilitySlots) {
            viewabilityObserver.observe(viewabilitySlots);
        });
    });

    }


}
